export default __webpack_public_path__ + "static/Auto_Turret-8c0218cc3a6aa9129647249d6de31386.png";